module.exports = __webpack_public_path__ + "img/create.b60de439.svg";